export const gradeList = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2'];